const action = {};

action.changeScheduleSubmissionReport = payload => ({
  type: "CHANGE_SCHEDULE_SUBMISSION_INPUT",
  payload
});

export default action;
